'use client';

import dynamic from 'next/dynamic';
import type { ActivationsMapProps } from '@components/templates/employer/profile/details/LeafletMap';

const LeafletMap = dynamic(() => import('./LeafletMap'), { ssr: false });

/**
 * @description DynamicLeafletMap component.
 * It's either this or we make the DetailsSection a client component.
 */
export const DynamicLeafletMap = (props: ActivationsMapProps) => (<LeafletMap {...props} />);
